<template>
  <div class="logInComponent">
    <div class="logInContainer">
      <div class="logInCard">
        <div class="logoContainer">
          <img alt="ACG logo" class="logo" src="@/assets/img/logoblack.svg"/>
        </div>
        <validation-observer v-slot="{ handleSubmit }" tag="div">
          <form @submit.prevent="handleSubmit(formSubmit)" class="form form--login">
            <div class="inputContainer">
              <div>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="form-row">
                    <input class="emailInput" placeholder="E-mail" name="E-mail" type="text" v-model="loginForm.email"/>
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="form-row">
                    <input class="passInput" placeholder="Password" name="Password" type="password"
                           v-model="loginForm.psw"/>
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                
                <div class="text-link-login">
                  <router-link class="text-link " :to="{name: 'ForgotPassword'}">Forgot password</router-link>
                  <router-link class="text-link " :to="{name: 'Registration'}">Registration</router-link>
                </div>
              </div>
              <div class="error--s form__error" style="font-size:12px; color: red; margin-bottom: 10px;" v-if="error.length > 0">
                {{ error }}
              </div>
              <button type="submit" class="btn btn-green logInButton">Sign in</button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "{_field_} is required."
});

export default {
  data() {
    return {
      loginForm: {
        email: null,
        psw: null
      },
      error: []
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  created() {
  },
  methods: {
    formSubmit() {
      let _this = this

      _this.post('login',
          {
            email: _this.loginForm.email,
            password: _this.loginForm.psw
          },
          {}, function (response) {
            //success
            // //console.log(response.data)
            if (response.data.token != null || response.data.token != '' || response.data.token != undefined) {
              //console.log('sikeres belépés', response.data.user.user_type)
              localStorage.setItem('ebus_token', response.data.token)
              _this.$store.state.token = response.data.token
              _this.$store.dispatch('setUserData', response.data.user)
            }

          }, function (error) {
            //error
            //console.log('login error:', error.data)

            if (error.data.error == 'Not found!') {
              _this.error = 'Wrong user name or password'
            }
          }
      )
    }
  }
}
</script>